<template>
  <form @submit.prevent="submit">
    <b-alert v-if="error" show variant="danger" role="alert">{{ error }}</b-alert>
    <b-alert v-if="success" show variant="success" role="status">{{ $t('label.profilePasswordSuccess') }}</b-alert>
    <fieldset :disabled="saving">
      <div class="row">
        <div class="col-12 col-md-4"><b-form-group :label="$t('label.profileCurrentPassword')" label-for="profile-current-password"><b-form-input id="profile-current-password" v-model="currentPassword" :type="showPasswords ? 'text' : 'password'" autocomplete="current-password" required /></b-form-group></div>
        <div class="col-12 col-md-4"><b-form-group :label="$t('label.profileNewPassword')" label-for="profile-new-password"><b-form-input id="profile-new-password" v-model="newPassword" :type="showPasswords ? 'text' : 'password'" autocomplete="new-password" required /></b-form-group></div>
        <div class="col-12 col-md-4"><b-form-group :label="$t('label.profileConfirmPassword')" label-for="profile-confirm-password"><b-form-input id="profile-confirm-password" v-model="confirmation" :type="showPasswords ? 'text' : 'password'" autocomplete="new-password" required /></b-form-group></div>
      </div>
      <b-form-checkbox v-model="showPasswords" class="mb-3">{{ $t('label.profileShowPasswords') }}</b-form-checkbox>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button type="button" variant="outline-secondary" class="mr-2 mb-2" @click="reset">{{ $t('label.profilePasswordClear') }}</b-button>
        <b-button type="submit" variant="info" class="mb-2"><b-spinner v-if="saving" small class="mr-1" />{{ $t('label.profileChangePassword') }}</b-button>
      </div>
    </fieldset>
  </form>
</template>
<script>
import { authService } from "@/services/api/auth.service";
import { sharedHelper } from "@/utils";
export default {
  name: "ProfileChangePassword",
  data() { return { currentPassword: "", newPassword: "", confirmation: "", showPasswords: false, saving: false, error: "", success: false, requestId: 0 }; },
  beforeDestroy() { this.requestId++; this.currentPassword = ""; this.newPassword = ""; this.confirmation = ""; },
  methods: {
    reset() { if (this.saving) return; this.currentPassword = ""; this.newPassword = ""; this.confirmation = ""; this.showPasswords = false; this.error = ""; this.success = false; },
    async submit() {
      if (this.saving) return;
      this.error = ""; this.success = false;
      if (!this.currentPassword || !this.newPassword || !this.confirmation) { this.error = this.$t("label.profilePasswordRequired"); return; }
      if (this.newPassword !== this.confirmation) { this.error = this.$t("label.profilePasswordMismatch"); return; }
      const request = ++this.requestId;
      this.saving = true;
      try {
        const result = await authService.changePassword({ current_password: this.currentPassword, new_password: this.newPassword, new_password_confirmation: this.confirmation });
        if (request !== this.requestId) return;
        if (!result?.success) throw new Error(result?.message || this.$t("label.profilePasswordError"));
        this.currentPassword = ""; this.newPassword = ""; this.confirmation = ""; this.showPasswords = false; this.success = true;
      } catch (error) {
        if (request !== this.requestId) return;
        const fields = error?.response?.data?.errors;
        const details = fields && typeof fields === "object" ? Object.values(fields).flat().filter(value => typeof value === "string").join(" ") : "";
        this.error = details || sharedHelper.getErrorMessage(error) || this.$t("label.profilePasswordError");
      } finally { if (request === this.requestId) this.saving = false; }
    },
  },
};
</script>
